import { render, staticRenderFns } from "./ledger.vue?vue&type=template&id=5e983d06&"
import script from "./ledger.vue?vue&type=script&lang=ts&"
export * from "./ledger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports